module.exports = __webpack_public_path__ + "img/banner5.133d1fb5.jpg";